import React, { useState } from "react";
import { makeStyles, Drawer, Typography, Box, Theme } from "@material-ui/core";
import { styled } from "@material-ui/core/styles";
import CancelIcon from "@material-ui/icons/Clear";
import Button from "components/design-system/atoms/Button";

interface StylesProps {
  width: string;
  backgroundColor?: string;
  hasTitle: boolean;
}
const PointerBox = styled("span")({
  cursor: "pointer",
});

const ZeroPaddingButton = styled(Button)<Theme>(({ theme }) => ({
  padding: 0,
  height: theme.spacing(3),
  width: theme.spacing(3),
}));

export default function InformationDrawer({
  button,
  anchor,
  width,
  backgroundColor = null,
  title = null,
  preventOpening = false,
  ...props
}) {
  const classes = useStyle({ width, backgroundColor, hasTitle: !!title });
  const [openDrawer, setOpenDrawer] = useState(false);

  const handleClose = () => {
    setOpenDrawer(false);
  };

  return (
    <>
      <PointerBox onClick={() => !preventOpening && setOpenDrawer(true)}>{button}</PointerBox>
      <Drawer
        anchor={anchor}
        open={openDrawer}
        transitionDuration={400}
        className={classes.drawer}
        onBackdropClick={handleClose}
      >
        <div className={classes.header}>
          {title && (
            <Typography variant="h3" className={classes.title}>
              {title}
            </Typography>
          )}
          <ZeroPaddingButton dimension="small" version="invisible" onClick={handleClose}>
            <CancelIcon className={classes.closeIcon} />
          </ZeroPaddingButton>
        </div>
        <Box className={classes.content}>{props.children({ handleClose })}</Box>
      </Drawer>
    </>
  );
}

const useStyle = makeStyles<Theme, StylesProps>((theme) => ({
  content: {
    padding: theme.spacing(2),
  },
  header: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    borderBottom: (props) => (props.hasTitle ? "1px solid #1A8E96" : "none"),
    display: "flex",
    alignItems: "center",
    justifyContent: (props) => (props.hasTitle ? "space-between" : "flex-end"),
  },
  closeIcon: {
    color: theme.palette.secondary.main,
  },
  title: {
    color: theme.palette.secondary.main,
  },
  drawer: {
    // Override drawer zIndex to allow showing Google autocomplete on top of it
    "z-index": "100 !important",
    // Override drawer positioning to allow overlaping on top of mobile view
    [theme.breakpoints.down("sm")]: {
      position: "static !important",
    },
    "& .MuiPaper-root": {
      width: (props) => props.width,
      backgroundColor: (props) => props.backgroundColor || theme.palette.background.default,
      height: "100%",
      overflowX: "hidden",
      borderRadius: "12px 0px 0px 12px;",
    },
  },
}));
